import type { PrepChatMessage, PaginationState } from '../types/charterWsTypes'

export interface CharterPrepWsState {
  isConnected: boolean
  messages: PrepChatMessage[]
  completedSections: Record<string, string> // section_key → ISO timestamp
  activeSectionKey: string | null
  isStreaming: boolean
  currentStreamId: string | null
  profileApprovalRequired: boolean
  isGeneratingProfile: boolean
  profileApproved: boolean
  profile: Record<string, unknown> | null
  sharingMode: string
  /** True once the user has explicitly chosen a sharing mode (gates Approve). */
  sharingModeSelected: boolean
  visibleSections: string[]
  sectionOrder: string[]
  status: string | null
  qualityCheckFailed: {
    section_key: string
    trigger_type: string | null
    coaching_hint: string | null
  } | null
  error: string | null
  pagination: PaginationState | null
}

const charterPrepWsInitialState: CharterPrepWsState = {
  isConnected: false,
  messages: [],
  completedSections: {},
  activeSectionKey: null,
  isStreaming: false,
  currentStreamId: null,
  profileApprovalRequired: false,
  isGeneratingProfile: false,
  profileApproved: false,
  profile: null,
  sharingMode: 'auto',
  sharingModeSelected: false,
  visibleSections: [],
  sectionOrder: [],
  status: null,
  qualityCheckFailed: null,
  error: null,
  pagination: null,
}

export default charterPrepWsInitialState
